import {
  ADD_PG,
} from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const addAddPg = (payload) => {
  return apiInstance.post(ADD_PG, payload);
};
